var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.selectedItems.length > 0
        ? _c(
            "div",
            { staticClass: "d-inline-block mb-1" },
            _vm._l(_vm.selectedItems, function(tag) {
              return _c(
                "b-form-tag",
                {
                  key: tag.id,
                  staticClass: "mr-1",
                  attrs: {
                    title: tag.name,
                    size: "sm",
                    variant: "info",
                    pill: ""
                  },
                  on: {
                    remove: function($event) {
                      return _vm.removeTag(tag.id)
                    }
                  }
                },
                [_vm._v(_vm._s(tag.name))]
              )
            }),
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "b-input-group",
        [
          _c(
            "b-dropdown",
            {
              staticClass: "flex-grow-1 custom-scroll-menu",
              attrs: {
                disabled: _vm.isDisabled,
                variant: "outline-secondary",
                size: "sm",
                "no-caret": "",
                "menu-class": "z-index-dropdown",
                "toggle-class":
                  "d-flex justify-content-between align-items-center bg-white text-dark border shadow-none"
              },
              scopedSlots: _vm._u([
                {
                  key: "button-content",
                  fn: function() {
                    return [
                      _c(
                        "span",
                        {
                          staticClass: "text-truncate mr-2",
                          class:
                            _vm.selectedIds.length === 0
                              ? "text-muted"
                              : "text-dark"
                        },
                        [
                          _vm._v(
                            "\n          " +
                              _vm._s(_vm.displayText) +
                              "\n        "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c("font-awesome-icon", {
                        staticClass: "text-muted",
                        attrs: { icon: "chevron-down", size: "xs" }
                      })
                    ]
                  },
                  proxy: true
                }
              ])
            },
            [
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "py-1 px-3" },
                [
                  _c("filters-drawer", {
                    staticClass: "mb-2",
                    attrs: { query: _vm.query, hideSearchButton: true },
                    on: {
                      "update:query": function($event) {
                        _vm.query = $event
                      },
                      submit: _vm.onSearch
                    }
                  }),
                  _vm._v(" "),
                  _vm.items.length === 0
                    ? _c("div", { staticClass: "text-muted text-small" }, [
                        _vm._v("\n          Ничего не найдено\n        ")
                      ])
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "scrollable-dropdown-content" },
                [
                  _c(
                    "b-list-group",
                    {
                      staticClass: "text-small",
                      attrs: { flush: "" },
                      on: {
                        click: function($event) {
                          $event.stopPropagation()
                        }
                      }
                    },
                    _vm._l(_vm.items, function(option) {
                      return _c(
                        "b-list-group-item",
                        {
                          key: option.id,
                          staticClass:
                            "d-flex align-items-center justify-content-between py-2 px-3",
                          attrs: { button: "", action: "" },
                          on: {
                            click: function($event) {
                              return _vm.toggleItem(option)
                            }
                          }
                        },
                        [
                          _c("span", [_vm._v(_vm._s(option.name))]),
                          _vm._v(" "),
                          _vm.selectedIds.includes(option.id)
                            ? _c("font-awesome-icon", {
                                attrs: { icon: "check" }
                              })
                            : _vm._e()
                        ],
                        1
                      )
                    }),
                    1
                  )
                ],
                1
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "b-input-group-append",
            [
              _c(
                "b-button",
                {
                  attrs: {
                    size: "sm",
                    variant: "secondary",
                    disabled: _vm.selectedIds.length === 0 || _vm.isDisabled
                  },
                  on: { click: _vm.onClear }
                },
                [_c("font-awesome-icon", { attrs: { icon: "times-circle" } })],
                1
              ),
              _vm._v(" "),
              _vm.canCreateCatalog()
                ? _c(
                    "b-button",
                    {
                      attrs: {
                        size: "sm",
                        variant: "success",
                        disabled: _vm.isDisabled
                      },
                      on: { click: _vm.showModalCatalog }
                    },
                    [_c("font-awesome-icon", { attrs: { icon: "plus" } })],
                    1
                  )
                : _vm._e()
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.isModalVisible
        ? _c("WorkerSkill", {
            attrs: { "exact-id": 0 },
            on: {
              "modal-closed": function($event) {
                _vm.isModalVisible = false
              },
              refresh: _vm.onCreated
            }
          })
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e671b868", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-e671b868","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Catalogs/WorkerSkills/WorkerSkillMultiSelect.vue
// module id = null
// module chunks = 